
import ReducerRegistry from '../../../features/base/redux/ReducerRegistry'

import { ADD_AUDIT_MESSAGES,SHOW_AUDIT_MESSAGE_LIST } from './actionTypes';

const DEFAULT_STATE = {

    auditorMessages: [],
    isMessageListOpen: false
};

ReducerRegistry.register(
    'features/meeting-auditor',
    (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case ADD_AUDIT_MESSAGES:
            return {
                ...state,
                auditorMessages: action.auditorMessages
            };

        case SHOW_AUDIT_MESSAGE_LIST:
            return {
                ...state,
                isMessageListOpen: action.isMessageListOpen
            };

        default:
            return state;
        }
    });